import { CommonModule } from '@angular/common';
import { Component, Input, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SharedComponents } from '../../shared.module';

@Component({
  selector: 'app-generic-modal',
  standalone: true,
  imports: [CommonModule, ...SharedComponents],
  templateUrl: './generic-modal.component.html',
  styleUrl: './generic-modal.component.scss'
})
export class GenericModalComponent {
  activeModal = inject(NgbActiveModal);
  isActive: boolean = false;

  @Input()
  title: string = '';

  @Input()
  data: any = {};

  @Input()
  contentList: any = [];
}
